"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createException = exports.RegistryError = exports.RegistryErrorCode = void 0;
const FetchError = 100;
const NoComponentsAtHostBundle = 201;
const NoComponentsAtComponentBundle = 202;
const NoRegistryOverrideForHost = 301;
const Unknown = -1;
exports.RegistryErrorCode = {
    FetchError,
    NoComponentsAtHostBundle,
    NoComponentsAtComponentBundle,
    Unknown,
    NoRegistryOverrideForHost,
};
/**
 * NOTE: all error methods should be defined as the arrow functions
 * because of typescript issue when target is set `es5`
 */
class RegistryError extends Error {
    constructor(message, code = Unknown) {
        const stack = [`Registry Error - "${code}"`, message];
        super(stack.filter(m => !!m).join('\n'));
        this.name = this.constructor.name;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RegistryError);
        }
    }
}
exports.RegistryError = RegistryError;
const createException = (code, message = '') => {
    const e = new RegistryError(message, code);
    if (Error.captureStackTrace) {
        Error.captureStackTrace(e, exports.createException);
    }
    return e;
};
exports.createException = createException;
//# sourceMappingURL=createException.js.map